import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../services/api/api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormaDosaggioCriteria} from '../../model/FormaDosaggioCriteria';
import {SpinnerService} from '../../services/spinner/spinner.service';
import {catchError, of, tap} from 'rxjs';
import {BreadcrumbsService} from '../../services/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-results-page',
  templateUrl: './results-page.component.html',
  styleUrls: ['./results-page.component.scss']
})
export class ResultsPageComponent implements OnInit {

  public breadcrumbLabel = $localize`:result-page|breadcrumb-text-link@@result-page.breadcrumb-text:Risultati`;
  data: any = [];
  resLen = this.data.length;
  query = '';
  page = 0;
  allPages: any;
  filters: any;
  caricamento = false;
  error: any = undefined;
  exactSearch = false;
  spellingCorrection = false;

  url: any;


  constructor(
    private router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    private ss: SpinnerService,
    private breadcrumbService: BreadcrumbsService) {
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.route.queryParams
      .subscribe(params => {

        let paramsClone = JSON.stringify(params) as any;
        paramsClone = JSON.parse(paramsClone) as object;

        this.data = [];
        this.exactSearch = params['exact'] && params['exact'] == 'true';
        this.spellingCorrection = params['spellingCorrection'] && params['spellingCorrection'] == 'true';

        if (params['query'] !== undefined) {
          paramsClone.query = decodeURI(params['query']);
        }

        this.filters = structuredClone(params);
        this.loadData(paramsClone);

        // Otteniamo il percorso del link
        const urlTree = this.router.createUrlTree([], {relativeTo: this.route, queryParams: params});
        this.url = this.router.serializeUrl(urlTree);

        this.breadcrumbService.pushUrl({label: this.breadcrumbLabel, routerLink: this.url});
      });
  }

  search(queryEvent: { queryString: string, selectedFromAutocomplete: boolean }, filters?: FormaDosaggioCriteria, forced = false) {
    let queryParams: any = {query: queryEvent.queryString};

    // Imposto flags exact e spelling:
    this.searchParamsLogic(queryEvent, forced);
  
      
    if (this.spellingCorrection) {
      queryParams = {...queryParams, spellingCorrection: true};
    }

    if (this.exactSearch) {
      queryParams = {...queryParams, exact: true};
    }

    if (filters) {
      queryParams = {...queryParams, ...filters};
    } else {
      this.page = 0;
    }

    this.router.navigate([], {relativeTo: this.route, queryParams: queryParams});

  }

  private searchParamsLogic(queryEvent: { queryString: string; selectedFromAutocomplete: boolean }, forced: boolean) {
    if (queryEvent.selectedFromAutocomplete ) {
      this.exactSearch = true;
      this.spellingCorrection = false;
    }

    if (!queryEvent.selectedFromAutocomplete) {
      this.spellingCorrection = true;
      this.exactSearch = false;
    }
    
  

    if (forced) {
      this.spellingCorrection = false;
      this.exactSearch = false;
    }
  }

  filteredSearch(event: FormaDosaggioCriteria) {
    this.breadcrumbService.popUrl()
    this.data = [];
    this.page = 0;
    this.search({queryString: this.query, selectedFromAutocomplete: this.exactSearch}, event);
  }

  loadData(params: any) {
    this.query = params.query;

    params = {...params, page: this.page};

    if (this.exactSearch) {
      params = {...params, exact: true};
    }

    this.ss.show();

    this.api.cerca(params)
      .pipe(
        tap(() => {
          this.ss.hide();
        }),
        tap((res) => {
          this.data = this.data.concat(res.data.content);
          this.resLen = res.data.totalElements;
          this.allPages = res.data.totalPages;
          if (res.errors && res.errors.length === 1) {
            this.query = res.message;
            this.error = res.errors[0];
          } else {
            this.error = undefined;
          }
        }),
        catchError((err) => {
          console.log(err);
          this.ss.hide();
          return of(null);
        })
      ).subscribe();
  }

  dettaglio(id: any) {
    this.router.navigate([`/dettaglio/${id}`]);
    // this.api.setRouteBreadCrumb(this.url);
  }

  scrollSearch() {
    if ((this.page + 1) < this.allPages) {
      this.page = this.page + 1;
      this.loadData(this.filters);
    }
  }
}
